// Lightweight client error logger: logs to the console AND reports to the
// backend so failures surface in the Admin dashboard (System tab).
// It must NEVER throw or block the app.
export function logError(context, error, extra) {
  const raw = error?.response?.data?.detail ?? error?.message ?? error;
  const message = typeof raw === "string" ? raw : JSON.stringify(raw);

  // eslint-disable-next-line no-console
  console.error(`[${context}]`, error);

  try {
    const payload = {
      context: String(context || "").slice(0, 200),
      message: String(message || "Unknown error").slice(0, 1000),
      stack: String(error?.stack || "").slice(0, 4000),
      url: typeof window !== "undefined" ? window.location.href : "",
      extra: extra ? (typeof extra === "string" ? extra : JSON.stringify(extra)).slice(0, 1000) : "",
    };
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    /* logging must never break the app */
  }
}
